<!-- @format -->

<article class="row" [attr.aria-label]="result.name">
  <div class="col-12" [ngClass]="{ 'col-md-10': loggedIn }">
    <div class="row course-unit-heading">
      <div class="results-name col-12">
        <div class="title-box" data-cy="course-unit-info-title">
          <a [uiSref]="courseUnitTitleLink" [uiParams]="{ courseUnitId: result.id }" data-cy="course-unit-info-link">
            <h3 class="courseunit-title">
              <sis-mark-string [target]="result.name" [query]="term" /> ({{ result.credits | creditRange: "TEXT" }})
            </h3>
          </a>
          <span class="courseunit-code">
            <sis-mark-string [target]="result.code" [query]="term" />
          </span>
        </div>
        @if (matchingOtherLang) {
          <div class="language-match">
            <span class="language-match-title" translate>SEARCH_LANGUAGE_MATCH</span>
            <span>{{ " " + result.nameMatch }}</span>
          </div>
        }
      </div>
    </div>

    <div class="row">
      @if (result.tweetText) {
        <div class="col-12 tweet-text">
          <p>{{ result.tweetText }}</p>
        </div>
      }
      <div class="col-12 col-md-5">
        <div class="tiny-static-form-group">
          <span class="label colon" translate>SEARCH_RESULT.ATTAINMENT_LANGUAGES</span>
          @if (!result.attainmentLanguageUrns || result.attainmentLanguageUrns.length === 0) {
            <span class="value" translate>SEARCH_RESULT.NO_INFO</span>
          }
          @for (languageUrn of result.attainmentLanguageUrns; track languageUrn; let i = $index) {
            <span class="value">
              {{ languageUrn | codeLocalizedName | async }}
              @if (result.attainmentLanguageUrns.length - 1 !== i) {
                <span>,</span>
              }
            </span>
          }
        </div>
        <div class="tiny-static-form-group">
          <span class="label colon" translate>SEARCH_RESULT.TEACHING_LANGUAGES</span>
          @if (curLangCodeUrns.length === 0) {
            <span class="value" translate>SEARCH_RESULT.NO_INFO</span>
          }
          @for (urn of curLangCodeUrns; track urn; let j = $index) {
            <span class="value">
              {{ urn | codeLocalizedName | async }}
              @if (curLangCodeUrns.length - 1 !== j) {
                <span>,</span>
              }
            </span>
          }
        </div>
        <div class="tiny-static-form-group">
          <span class="label colon" translate>SEARCH_RESULT.ACTIVITY_PERIODS</span>
          <span class="value">{{ renderedActivityPeriods }}</span>
        </div>
      </div>
      <div class="col-12 col-md-5">
        <div class="tiny-static-form-group">
          <span class="label colon" translate>SEARCH_RESULT.CURRICULUM_PERIOD</span>
          <span class="value">{{ renderedCurriculumPeriods }}</span>
        </div>
        <div class="tiny-static-form-group course-unit-search-result-organisations">
          <span class="label colon" translate>SEARCH_RESULT.ORGANIZATION</span>
          <sis-show-more-text
            [text]="organisationNames"
            [maxCharsBeforeOverFlow]="80"
            [showMoreButtonText]="'ARIA_LABEL.SHOW_MORE'"
            [showLessButtonText]="'ARIA_LABEL.SHOW_LESS'">
          </sis-show-more-text>
        </div>
        <div class="tiny-static-form-group">
          <span class="label colon" translate>SEARCH_RESULT.UNIVERSITY_ORG_IDS</span>
          @for (universityOrgId of result.universityOrgIds; track universityOrgId; let j = $index) {
            <span class="value">
              {{ (universityOrgId | organisation | async)?.name | localizedString }}
              @if (result.universityOrgIds.length - 1 !== j) {
                <span>,</span>
              }
            </span>
          }
        </div>
      </div>
    </div>
  </div>
  @if (loggedIn) {
    <div class="col-12 col-md-2">
      <div class="course-cart-actions float-md-right" aria-live="polite">
        <sis-button
          class="add-to-plan-button"
          [naked]="true"
          size="sm"
          (clicked)="addToPlan()"
          [ariaLabel]="('SIS_COMPONENTS.STUDY.PLACE_TO_PLAN' | translate) + ' ' + (result.name | plainText)">
          <span translate>SIS_COMPONENTS.STUDY.PLACE_TO_PLAN</span>
        </sis-button>
        @if (!isInCart) {
          <sis-button
            [naked]="true"
            size="sm"
            (clicked)="addToCart()"
            dataCy="add-to-course-cart"
            [ariaLabel]="('ARIA_LABEL.ADD_TO_CART' | translate) + ' ' + (result.name | plainText)">
            <sis-icon icon="list-add"></sis-icon>
            <span translate>ADD_TO_CART</span>
          </sis-button>
        }
        @if (isInCart) {
          <sis-button
            [naked]="true"
            size="sm"
            variant="secondary"
            (clicked)="removeFromCart()"
            dataCy="remove-from-course-cart"
            [ariaLabel]="('ARIA_LABEL.REMOVE_FROM_CART' | translate) + ' ' + (result.name | plainText)">
            <sis-icon icon="list-minus"></sis-icon>
            <span translate>REMOVE_FROM_CART</span>
          </sis-button>
        }
      </div>
    </div>
  }
</article>
